import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "period-toggle-wrap" };
const _hoisted_2 = ["onClick"];
import { ref, watch, onMounted, nextTick } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PeriodToggle',
    props: {
        periods: {},
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const optionRefs = ref([]);
        const activeLeft = ref(2);
        const activeWidth = ref(0);
        function setOptionRef(index, el) {
            optionRefs.value[index] = el;
        }
        function updateActive() {
            const i = props.periods.findIndex(p => p.key === props.modelValue);
            const el = optionRefs.value[i];
            if (!el)
                return;
            activeLeft.value = el.offsetLeft;
            activeWidth.value = el.offsetWidth;
        }
        watch(() => props.modelValue, () => nextTick(updateActive));
        watch(() => props.periods, () => nextTick(updateActive));
        onMounted(() => nextTick(updateActive));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "period-toggle-active",
                    style: _normalizeStyle({ left: activeLeft.value + 'px', width: activeWidth.value + 'px' })
                }, null, 4),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (p, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: p.key,
                        ref_for: true,
                        ref: el => setOptionRef(i, el),
                        class: _normalizeClass(['period-toggle-option', { selected: _ctx.modelValue === p.key }]),
                        onClick: ($event) => (emit('update:modelValue', p.key))
                    }, _toDisplayString(p.label), 11, _hoisted_2));
                }), 128))
            ]));
        };
    }
});
